"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PipIcon = _interopRequireDefault(require("./PipIcon"));
var _default = (0, _styledComponents["default"])(_PipIcon["default"]).withConfig({
  displayName: "HelpInfo",
  componentId: "sc-1xtehvc-0"
})(["background-position:-224px -253px;top:0;width:20px;height:20px;transform:scale(0.8) translate(20%);float:none;cursor:pointer;pointer-events:auto;user-select:auto;margin-top:10px;margin-bottom:-5px;margin-right:10px;"]);
exports["default"] = _default;
//# sourceMappingURL=HelpInfo.js.map